<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20.6366 1.36338C19.5688 0.29554 17.8375 0.29554 16.7696 1.36338L15.5643 2.56874L19.4313 6.43573L20.6366 5.23037C21.7045 4.16253 21.7045 2.43122 20.6366 1.36338Z"
                :fill="color"
            />
            <path
                d="M18.3264 7.54059L14.4594 3.6736L5.70854 12.4245C5.06605 13.067 4.59377 13.8594 4.33437 14.7302L3.50127 17.527C3.41937 17.8019 3.49473 18.0996 3.69758 18.3024C3.90042 18.5053 4.19811 18.5806 4.47304 18.4987L7.2698 17.6656C8.1406 17.4062 8.93305 16.9339 9.57554 16.2915L18.3264 7.54059Z"
                :fill="color"
            />
            <path
                d="M3.46875 4.46874C1.74286 4.46874 0.34375 5.86785 0.34375 7.59374V18.5312C0.34375 20.2571 1.74286 21.6562 3.46875 21.6562H14.4062C16.1321 21.6562 17.5312 20.2571 17.5312 18.5312V13.0625C17.5312 12.631 17.1815 12.2812 16.75 12.2812C16.3185 12.2812 15.9688 12.631 15.9688 13.0625V18.5312C15.9688 19.3942 15.2692 20.0937 14.4062 20.0937H3.46875C2.6058 20.0937 1.90625 19.3942 1.90625 18.5312V7.59374C1.90625 6.7308 2.60581 6.03124 3.46875 6.03124H8.9375C9.36897 6.03124 9.71875 5.68146 9.71875 5.24999C9.71875 4.81852 9.36897 4.46874 8.9375 4.46874H3.46875Z"
                :fill="color"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgPencil2',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>